// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"23150c9b","64":"60599fe0","211":"46df7795","453":"d628cac9","496":"3b3c593b","523":"92f8d20f","549":"a9966b4d","624":"fd4e7ce4","644":"4aed2ef1","813":"18c2ce3d"}[chunkId] + ".chunk.js";
};